/**
 * VolumeRole - Role para conversão de unidades de volume
 *
 * Implementa os 4 pilares via SimpleRole base class.
 * Para uso funcional, prefira importar dos pilares diretamente.
 *
 * @example
 * // OOP style
 * import { volumeRole } from '@attrx/role-morphic/volume';
 * volumeRole.convert('gallon_us', 'liter', 1);  // 3.785411784
 *
 * // Functional style (preferido)
 * import { convertVolume } from '@attrx/role-morphic/volume/convert';
 * convertVolume('gallon_us', 'liter', 1);  // 3.785411784
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { VOLUME_UNITS, VOLUME_ALIASES } from "./constants";

// =============================================================================
// VOLUME ROLE CLASS
// =============================================================================

export class VolumeRole extends SimpleRole {
  readonly name = "volume";
  readonly base = "liter";
  readonly units = VOLUME_UNITS;
  readonly aliases = VOLUME_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Volume cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da VolumeRole */
export const volumeRole = new VolumeRole();
